import React from 'react'
import cn from 'classnames'
import convert from 'htmr'
import { FormattedMessage } from 'react-intl'
import CollapsableBox from 'js/components/CollapsableBox/CollapsableBox'

function Answer({ answer }) {
  return answer.map((paragraph, j) => {
    if (typeof paragraph === 'string') {
      return (
        <p className="s-text" key={j}>
          {convert(paragraph)}
        </p>
      )
    } else {
      return (
        <p key={j}>
          <FormattedMessage {...paragraph} />
        </p>
      )
    }
  })
}

type Props = {
  questions: any[]
  heading: string | boolean
  background?: 'white' | 'beige-lightest'
  border?: boolean
}

const FAQ = ({
  heading = 'FAQ',
  background = 'white',
  border = false,
  questions,
}: Props) => (
  <div>
    {heading && <h2 className="my-24 text-beige-darker type-32">{heading}</h2>}
    <div
      className={cn(
        'mx-auto mt-24 max-w-968 text-left',
        border && 'rounded-12 border-1 border-Border',
      )}
    >
      {questions.map((question, i) => {
        const summary =
          typeof question.q === 'string' ? (
            convert(question.q)
          ) : (
            <FormattedMessage
              {...question.q}
              values={{
                b: function BoldText(...chunks) {
                  return <strong className="font-demibold">{chunks}</strong>
                },
              }}
            />
          )
        return (
          <CollapsableBox
            summary={summary}
            details={<Answer answer={question.a} />}
            key={`question${i}`}
            background={background}
          />
        )
      })}
    </div>
  </div>
)

export default FAQ
